<template>
  <div>
    <video-pop-up />
    <drawer @toggleSidebar="toggleSidebar" :sidebar="sidebar" />
    <header-one image="logo.png" @toggleSidebar="toggleSidebar" />
    <hero />

    <div class="conference-wrap">
      <div class="global-bg" :style="{backgroundImage: `url(${require('@/assets/images/section-bg.png')})`}"></div>
      <div id="brief"><Brief /></div>
      <div id="guest"><Guest /></div>
      <div id="schedule"><Schedule /></div>
      <div id="org"><Organize /></div>
    </div>

    <footer-one />
    <div class="go-top-area">
      <div class="go-top-wrap">
        <div class="go-top-btn-wrap">
          <a href="#" class="go-top go-top-btn d-block">
            <i class="fa fa-angle-double-up"></i>
            <i class="fa fa-angle-double-up"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderOne from "../Utility/Header/index";
import Hero from "./Hero.vue";
import FooterOne from "../Utility/Footer/FooterOne.vue";
import Drawer from "../Mobile/Drawer.vue";
import VideoPopUp from "../Utility/VideoPopUp.vue";
import Brief from "@/components/ConferenceSection/Brief";
import Guest from "@/components/ConferenceSection/Guest";
import Schedule from "@/components/ConferenceSection/Schedule";
import Organize from "@/components/ConferenceSection/Organize";
import { eventBus } from '@/utils/eventBus.js';

export default {
  components: {
    Hero,
    VideoPopUp,
    Drawer,
    HeaderOne,
    FooterOne,
    Brief,
    Guest,
    Schedule,
    Organize,
  },
  inject: ['dataWrapper', 'fetchStatus'],
  data: () => ({
    sidebar: false,
    isScrolling: false,
    isHomeClick: false,
  }),
  created() {
    document.addEventListener("scroll", this.topToBottom);
    eventBus.$on('scroll-to-anchor', this.scrollToTarget);
    // 🔥 监听首页点击事件
    eventBus.$on('clear-hash-and-scroll', this.handleHomeClick);
    
    if (this.$route.hash) {
      this.$nextTick(() => {
        setTimeout(() => {
          this.scrollToTarget(this.$route.hash);
        }, 500);
      });
    }
  },
  beforeDestroy() {
    document.removeEventListener("scroll", this.topToBottom);
    eventBus.$off('scroll-to-anchor', this.scrollToTarget);
    eventBus.$off('clear-hash-and-scroll', this.handleHomeClick);
  },
  watch: {
    '$route.hash': {
      handler(hash) {
        // 🔥 如果是首页点击，跳过所有滚动
        if (this.isHomeClick) {
          return;
        }
        if (hash && !this.isScrolling) {
          setTimeout(() => {
            this.scrollToTarget(hash);
          }, 200);
        }
      },
      immediate: true
    },
    'fetchStatus.isFetched': {
      handler(newVal) {
        if (newVal) {
          console.log(newVal);
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    toggleSidebar() {
      this.sidebar = !this.sidebar;
    },
    topToBottom() {
      const result = document.querySelector(".go-top");
      if (!result) return;
      if (
        document.body.scrollTop > window.innerHeight ||
        document.documentElement.scrollTop > window.innerHeight
      ) {
        result.classList.add("active");
      } else {
        result.classList.remove("active");
      }
    },
    // 🔥 处理首页点击
    handleHomeClick() {
      // 立即设置标记，阻止任何滚动
      this.isHomeClick = true;
      
      // 滚动到顶部
      window.scrollTo({ top: 0, behavior: 'smooth' });
      
      // 延迟重置标记，确保路由切换完成
      setTimeout(() => {
        this.isHomeClick = false;
      }, 800);
    },
    scrollToTarget(hash) {
      // 🔥 多次检查 isHomeClick
      if (this.isHomeClick) {
        return;
      }
      
      // 🔥 如果 hash 为空，直接返回
      if (!hash || hash === '#') {
        return;
      }
      
      const target = document.querySelector(hash);
      if (!target) {
        setTimeout(() => {
          this.scrollToTarget(hash);
        }, 300);
        return;
      }

      this.isScrolling = true;
      const header = document.querySelector('.header-area');
      const headerHeight = header ? header.offsetHeight : 80;
      const targetRect = target.getBoundingClientRect();
      const offsetPosition = targetRect.top + window.pageYOffset - headerHeight - 20;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });

      setTimeout(() => {
        this.isScrolling = false;
      }, 600);
    }
  },
};
</script>

<style scoped>
.single-play-post-area .single-play-box {
  padding: 23px 12px !important;
}

.custom-corp-img {
  width: 100px;
  height: auto;
  object-fit: cover;
  object-position: center;
}

.upcoming-matches-flag {
  width: 100px;
  flex-shrink: 0;
}

.conference-wrap {
  position: relative;
  width: 100%;
  margin-top: 0;
  padding-top: 0;
}

.global-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center top;
  z-index: -1;
}

#brief,
#guest,
#schedule,
#org {
  scroll-margin-top: 150px !important;
  scroll-padding-top: 150px !important;
}

#brief *,
#guest *,
#schedule *,
#org * {
  scroll-margin-top: inherit !important;
}
</style>